import { Component, inject } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { DataService } from '../../services/data';
import { AsyncPipe } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-apply',
  imports: [AsyncPipe, RouterModule],
  template: `
<div class="container mt-4 mb-5">
  <div class="row">
    <div class="col-lg-10 offset-lg-1">
      @if (settings$ | async; as settings) {
        <h1 class="display-5 mb-4">Apply & Contact</h1>

        <div class="row g-4 mb-5">
          <div class="col-md-6">
            <div class="card h-100 shadow-sm border-0 bg-light p-4">
              <h3 class="h5 mb-3">Why Rent With Us?</h3>
              <p class="text-muted">Why put up with absentee landlords or prolonged maintenance issues?
              All of our friendly staff and owners are located right here in Columbia,
              MO, so there is always someone available to address your concerns.</p>
            </div>
          </div>
          <div class="col-md-6">
            <div class="card h-100 shadow-sm border-0 p-4" style="background-color: #fcfcfc;">
              <h3 class="h5 mb-3">Paper Application</h3>
              <p class="text-muted">Already know the unit you want?
                  <a href="resources/HPM-App.doc" class="fw-bold">Download</a> a copy of our lease application and submit by email to <a [href]="'mailto:' + settings.email" class="text-decoration-none fw-bold">{{ settings.email }}</a>,
                  or call <a [href]="'tel:' + settings.phone" class="text-decoration-none fw-bold">{{ settings.phone }}</a> to arrange delivery by postal mail or in person.
              </p>
            </div>
          </div>
        </div>

        <div class="card h-100 shadow-sm border-0 p-4 p-md-5">
          <h2 class="h3 mb-4 border-bottom pb-3">How to Apply</h2>

          <div class="mb-4">
            <p class="lead">Applying for your next rental is easy!</p>
            <ol class="list-group list-group-numbered list-group-flush mb-4">
              <li class="list-group-item bg-transparent border-0 px-0">
                Go to our <a routerLink="/" class="fw-bold">Home page</a>.
              </li>
              <li class="list-group-item bg-transparent border-0 px-0">
                Scroll down to our <strong>Available Listings</strong> section.
              </li>
              <li class="list-group-item bg-transparent border-0 px-0">
                Find the specific listing you are interested in and click the <strong>Apply Now</strong> button.
              </li>
            </ol>
          </div>

          <div class="bg-light p-4 rounded-3">
            <h3 class="h5 mb-3">Questions? Reach out directly</h3>
            <p class="mb-2">
              <i class="bi bi-envelope-fill me-2"></i>
              Email: <a [href]="'mailto:' + settings.email" class="text-decoration-none fw-bold">{{ settings.email }}</a>
            </p>
            <p class="mb-0">
              <i class="bi bi-telephone-fill me-2"></i>
              Phone: <a [href]="'tel:' + settings.phone" class="text-decoration-none fw-bold">{{ settings.phone }}</a>
            </p>
          </div>
        </div>
      }
    </div>
  </div>
</div>
  `,
  styles: ``,
})
export class Apply {
  private dataService = inject(DataService);
  settings$ = this.dataService.getSettings();

  constructor(private titleService: Title, private metaService: Meta) {
    this.titleService.setTitle('Apply - RentMU.com');
    this.metaService.updateTag({ name: 'description', content: 'Learn how to apply for student housing or contact Haker Property Management in Columbia, MO.' });
  }
}
